import * as React from "react";
import { StatusPageStore } from "../../lib/index";
import { Alert } from "react-bootstrap";
import styles from "./StatusPageWidget.scss";
import { inject, observer } from "mobx-react";
import { StatusPageMessageGenerator, StatusPageError,  } from "./StatusPage";
import icon from "../../static/brand/icon200.png";



interface  IStatusPageWidgetLogin{
	statusPageStore? : StatusPageStore;
}

@inject ("statusPageStore")
@observer
export class StatusPageWidgetLogin extends React.Component <IStatusPageWidgetLogin, {}>{
	constructor(props) {
		super(props);
	}

	private validateColor() {
		switch (this.props.statusPageStore.status.status.indicator){
			case "none":
				return	this.props.statusPageStore.status.incidents.length > 0 ? "danger" : "info"; //check if there are incidents.
			case "minor": return "warning";
			default: return "danger";
		}
	}

	public render() {

		try {
			const status = this.props.statusPageStore.status;
			let incidents = StatusPageMessageGenerator.getIncidents(status, 11, true);
			let maintance = StatusPageMessageGenerator.getMaintence(status, 11, true);
			return(
				(this.props.statusPageStore.status.scheduled_maintenances.length > 0
				|| (this.props.statusPageStore.status.incidents.length > 0 || this.props.statusPageStore.status.status.indicator !== "none"))  &&
				<Alert bsStyle={`${this.validateColor()}`} style= {{paddingBottom: "5px"}}>
					{incidents}
					{((status.scheduled_maintenances.length > 0) && (status.incidents.length > 0)) && <hr className={styles.hrStatus}/>}
					{maintance}

					{/* after messages*/}
					<hr className={styles.hrStatus}/>
					<a style={{fontSize: 10}} target = "_blank" href = "http://status.fleetplan.net/">
						<img
							src={icon}
							style={{ height: "12px", width: "12px", paddingBottom : "2px" }}
						/>

					{" "}statuspage.io
					</a>
					<p
						className={`pull-right`}
						style={{fontSize: 10, color: "grey", fontStyle: "italic"}}
					>
						Last refresh:{" "}
						{this.props.statusPageStore.date.getHours()}:
						{this.props.statusPageStore.date.getMinutes() < 10 ? "0" + this.props.statusPageStore.date.getMinutes() : this.props.statusPageStore.date.getMinutes()}
					</p>
				</Alert>
			);
		}catch (err) {
			if (err = "TypeError") {
				return(
					<Alert bsStyle={`danger`}>
						<StatusPageError fontSize = {10}/>
						<hr className={styles.hrStatus}/>
					<a style={{fontSize: 10}} target = "_blank" href = "http://status.fleetplan.net/">
						<img
							src={icon}
							style={{ height: "12px", width: "12px", paddingBottom : "2px" }}
						/>

					{" "}statuspage.io
					</a>
					<p
						className={`pull-right`}
						style={{fontSize: 10, color: "grey",
						fontStyle: "italic"}}
					>
						Last update:{" "}
						{this.props.statusPageStore.date.getHours()}:
						{this.props.statusPageStore.date.getMinutes() < 10 ? "0" + this.props.statusPageStore.date.getMinutes() : this.props.statusPageStore.date.getMinutes()}
					</p>
					</Alert>
				);
			} else {
					alert(this.props.statusPageStore + " " + err);
			}
		}
	}
}






// WEBPACK FOOTER //
// ./src/common/StatusPageWidget/StatusPageWidgetLogin.tsx